import { render, staticRenderFns } from "./Profiel.vue?vue&type=template&id=00b6fa4c&scoped=true"
import script from "./Profiel.vue?vue&type=script&lang=js"
export * from "./Profiel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b6fa4c",
  null
  
)

export default component.exports